// extracted by mini-css-extract-plugin
export default {"Weather_data_no_info":"WeatherDataNoInfo_Weather_data_no_info__0QBN8"};